import{b as e}from"./chunk-LSZKOVGW.mjs";import{j as o,k as r}from"./chunk-GTEBSQTL.mjs";var f=new o({locale:[e,r]});export{f as a};
